import React from 'react';
import { Modal } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Shared presentation only; each form owns its validation, submission and permissions.
const CreateRecordModal = ({
  show,
  onHide,
  isSubmitting,
  titleId,
  title,
  description,
  icon,
  size,
  dialogClassName,
  children,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    backdrop={isSubmitting ? 'static' : true}
    keyboard={!isSubmitting}
    centered
    size={size}
    dialogClassName={dialogClassName}
    className="create-record-modal"
    backdropClassName="create-record-modal-backdrop"
    aria-labelledby={titleId}
    aria-describedby={titleId + '-description'}
  >
    <Modal.Header closeButton={!isSubmitting}>
      <div className="create-record-modal__heading">
        <span className="create-record-modal__icon" aria-hidden="true">
          <FontAwesomeIcon icon={icon} />
        </span>
        <div className="create-record-modal__heading-text">
          <Modal.Title as="h2" id={titleId}>{title}</Modal.Title>
          <p id={titleId + '-description'} className="create-record-modal__description">
            {description}
          </p>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body>
      <p className="create-record-modal__required">
        Fields marked <span className="text-danger">*</span> are required.
      </p>
      {children}
    </Modal.Body>
  </Modal>
);

export default CreateRecordModal;
